import * as Redux from 'redux'
import * as Form from '../../../components/form'
import * as Sortable from '../../../components/sortable'
import * as Elasticsearch from '../../../elasticsearch'
import * as Request from '../../../request'
import * as Constants from './constants'
import * as Types from './types'
import * as Utils from './utils'

const opensReducer = (event: string) =>
  (state: Sortable.SortableData<Types.TopSource>, action: Request.SuccessAction) => {
  switch (action.type) {
    case Request.successConstant(event):
      const opens = Utils.getSourceOpens(action.payload.response)
      return state.map((s: Types.TopSource) =>
        Utils.updateTopSourceOpens(s, opens.filter((i: Types.TopSource) => i.sourceName === s.sourceName)))
    default:
      return state
  }
}

export const detailDataViewReducer = (event: string) =>
  (state: Sortable.SortableViewState, action: Request.SuccessAction) => {
  switch (action.type) {
    case Request.requestConstant(event):
      return {
        ...state,
        isLoading: true,
      }
    case Request.successConstant(event):
    case Request.errorConstant(event):
      return {
        ...state,
        isLoading: false,
      }
    default:
      return state
  }
}

const normalizeTypes: Sortable.TypeNormalizer<Types.TopSource> =
  (payload: any): Sortable.SortableData<Types.TopSource> => Utils.getTopSources(payload)

const reducerEvent = (eventName: string): Sortable.ReducerEvent<Types.TopSource> => {
  return {
    defaultSort: { field: 'count', dir: 'desc' },
    normalizer: normalizeTypes,
    requestEvent: eventName,
  }
}

const initialFieldValues: Types.FormFields = {
  community: null,
  dateRange: Elasticsearch.DateRanges.LastMonth,
  endDate: null,
  startDate: null,
  type: Elasticsearch.DocumentFieldNames.SourceName,
}

export const topSourcesReducer = (
  fetchEvent: string,
  filterEvent: string,
  impressionsEvent: string) => {
  const e = reducerEvent(fetchEvent)
  return Redux.combineReducers({
    data: Request.reducerChain([
      Sortable.stateReducer(e),
      opensReducer(impressionsEvent),
    ]),
    form: Form.createReducer(filterEvent, initialFieldValues),
    view: Request.reducerChain([
      Sortable.viewReducer(e),
    ]),
  })
}

export const reducer = topSourcesReducer(
  Constants.FETCH_TOP_SOURCES,
  Constants.TOP_SOURCES_FILTER,
  Constants.FETCH_TOP_SOURCE_SENDS)



// WEBPACK FOOTER //
// ./src/pages/reports/top-sources/reducer.ts